import { trackAnalytic as trackAnalyticCore, type AnalyticWithoutMetadata } from '@front/model'

export type { AnalyticWithoutMetadata }

export function trackAnalytic(event: string, analytic?: AnalyticWithoutMetadata): void {
  trackAnalyticCore(event, analytic)
}
